import React from "react";
import { Snackbar, SnackbarProps } from "@mui/material";
import Alert from "@mui/material/Alert";
import {
  SnackbarMessageProps,
  ISnackbarMessage,
} from "types/common-types";

type SnackbarMessageFields = {
  snackbarMessage: ISnackbarMessage | null;
  setSnackbarMessage: React.Dispatch<
    React.SetStateAction<SnackbarMessageProps | null>
  >;
} & SnackbarProps;

const SnackbarMessage = ({
  snackbarMessage,
  setSnackbarMessage,
  ...rest
}: SnackbarMessageFields) => {
  return (
    <>
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        open={!!snackbarMessage}
        autoHideDuration={snackbarMessage?.duration ?? 3000}
        onClose={() => setSnackbarMessage(null)}
        {...rest}
      >
        <Alert
          onClose={() => setSnackbarMessage(null)}
          severity={snackbarMessage?.severity}
        >
          {snackbarMessage?.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default SnackbarMessage;
